import type React from 'react';
import { useEffect } from 'react';

/**
 * Hook that detects clicks outside of the passed refs with option to specify refs to ignore
 */
export const useClickOutsideDetector: (
  refs: React.MutableRefObject<HTMLDivElement | HTMLUListElement | null>[],
  callback: () => void,
  ignoreRefs: React.MutableRefObject<HTMLDivElement | null>[]
) => void = (refs, callback, ignoreRefs = []) => {
  useEffect(() => {
    const handleClickOutside: (event: MouseEvent) => void = event => {
      const ignoreElement = ignoreRefs.some(ignoreRef => {
        return ignoreRef.current?.contains(event.target as Node);
      });
      if (!ignoreElement && refs.every(ref => !ref.current?.contains(event.target as Node))) {
        callback();
      }
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [refs, callback, ignoreRefs]);
};
